import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Checkbox from 'components/shared/StandaloneCheckbox';

export default class PropertyCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.property.value === "1"
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        const value = e.target.checked;
        this.setState({
            isChecked: value
        });

        this.props.handleChange(this.props.property.info.name, value ? "1" : "0");
    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({isChecked: this.props.property.value === "1" });
        }
    }

    render() {

        return (
            <Row style={{ margin: "0.75rem auto 0" }}>
                <Col sm="9" style={{ paddingLeft: '0', margin: "auto 0" }}>
                    {/* {this.props.property.info.displayName.replace(/([A-Z])/g, ' $1')} */}
                    {this.props.title}
                </Col>

                <Col sm="3" style={{ paddingRight: '0' }}>
                    {/* <input
                        name={this.props.property.info.name}
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={this.handleChange} /> */}
                    <Checkbox
                        style={{ fontSize: '0.25rem' }}
                        name={this.props.property.info.name}
                        checked={this.state.isChecked}
                        onChange={this.handleChange} />
                </Col>
            </Row>
        );
    };
}
